<template>
  <div class="connect-complete-page">
    <div class="complete-image"></div>
    <p class="complete-title">Smartwatch gekoppeld</p>
    <p class="complete-text">
      U heeft smartwatch
      <b>{{ getSmartwatchToConnect.smartwatchName }}</b> gekoppeld aan client <b>{{ getClientToConnect.initials }}</b>.
    </p>
    <button-component @click.native="goHome">Doorgaan</button-component>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ButtonComponent from '../components/button.component.vue';
import { RouteName } from '../utils/enums';

export default {
  name: 'connect-complete-page',
  components: {
    ButtonComponent
  },
  computed: {
    ...mapGetters(['getSmartwatchToConnect', 'getClientToConnect'])
  },
  methods: {
    goHome: function(){
      this.$router.push({ name: RouteName.HOME });
    }
  }
};
</script>
<style scoped lang="scss">
.connect-complete-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .complete-title {
    margin-bottom: 14px;
  }

  p {
    font-size: 16px;
    text-align: center;
  }
}

.complete-image {
  width: 95px;
  height: 120px;
  background-image: url('../assets/icons/watch-large-complete.svg');
  margin-bottom: 64px;
  margin-top: -60px;
}
</style>
